var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureRelease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.351,
    height: 12.618,
    viewBox: "0 0 16.351 12.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1487ba",
    stroke: "#1487ba",
    strokeWidth: "0.5px",
    d: "M20.313,7.775l1.234-1.209,3.159,3.226-3.226,3.159-1.209-1.234,1.991-1.95ZM16.5,15.765l-1.69-.356L17.267,3.74l1.69.356Zm-3-4.048-1.209,1.234L9.062,9.792l3.159-3.226,1.234,1.209L11.5,9.766Z",
    transform: "translate(-8.709 -3.444)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureRelease);
export default __webpack_public_path__ + "static/media/featureRelease.54f8a1a3.svg";
export { ForwardRef as ReactComponent };